import { createTRPCReact } from '@trpc/react-query'
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server'
import type { AppRouter } from '../api/_trpc/router.js'

export const trpc = createTRPCReact<AppRouter>()

/** Input types for every procedure, keyed by router path. */
export type RouterInputs = inferRouterInputs<AppRouter>
/** Serialized output types for every procedure (no transformer is configured, so Dates are ISO strings client-side). */
export type RouterOutputs = inferRouterOutputs<AppRouter>
